import { Link as RouterLink, NavLink } from 'react-router-dom'
import { Link as ScrollLink } from 'react-scroll'
import MobileMenu from '../MobileMenu/MobileMenu'

const Header = (props) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <header id="header" className={`wpo-site-header ${props.hclass}`}>
            <nav className="navigation navbar navbar-expand-lg navbar-light">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-lg-3 col-md-3 col-3 d-lg-none dl-block">
                            <div className="mobail-menu">
                                <MobileMenu />
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-6">
                            <div className="navbar-header">
                                {/* Logo için RouterLink kullanın */}
                                <RouterLink
                                    className="navbar-brand"
                                    to="/"
                                    onClick={ClickHandler}
                                >
                                    JanberkAltay
                                </RouterLink>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-1 col-1">
                            <div id="navbar" className="collapse navbar-collapse navigation-holder">
                                <button className="menu-close"><i className="ti-close"></i></button>
                                <ul className="nav navbar-nav mb-2 mb-lg-0">
                                    {/* Anasayfa için RouterLink kullanın */}
                                    <li className="menu-item-has-children">
                                        <RouterLink
                                            to="/"
                                            className={({ isActive }) => isActive ? "active" : ""}
                                            onClick={ClickHandler}
                                        >
                                            Anasayfa
                                        </RouterLink>
                                    </li>
                                    <li>
                                        <ScrollLink
                                            to="about"
                                            spy={true}
                                            smooth={true}
                                            duration={500}
                                            offset={-80}
                                            activeClass="active"
                                        >
                                            Hakkımda
                                        </ScrollLink>
                                    </li>
                                    <li>
                                        <ScrollLink
                                            to="projects"
                                            spy={true}
                                            smooth={true}
                                            duration={500}
                                            offset={-80}
                                            activeClass="active"
                                        >
                                            Projelerim
                                        </ScrollLink>
                                    </li>
                                    <li>
                                        <ScrollLink
                                            to="contact"
                                            spy={true}
                                            smooth={true}
                                            duration={500}
                                            offset={-80}
                                            activeClass="active"
                                        >
                                            İletişim
                                        </ScrollLink>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-2 col-2">
                            <div className="header-right">
                                <ScrollLink
                                    to="contact"
                                    spy={true}
                                    smooth={true}
                                    duration={500}
                                    offset={-80}
                                    className="theme-btn"
                                >
                                    İletişime Geç
                                </ScrollLink>
                                <div className="header-search-form-wrapper d-lg-none d-block">
                                    <div className="cart-search-contact">
                                        <button className="search-toggle-btn">
                                            <i className="fi flaticon-magnifiying-glass"></i>
                                        </button>
                                        <div className="header-search-form">
                                            <form>
                                                <div>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search here..."
                                                    />
                                                    <button type="submit">
                                                        <i className="fi flaticon-magnifiying-glass"></i>
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </header>
    )
}

export default Header;